import API from 'shared/api/API';
import { GET } from 'shared/utils/Executer';

class WorkspacesAPI {
  /**
   * Get all workspaces for the current user's organization
   * Note: This endpoint uses the user's organizationId from their JWT token
   * and returns workspaces the user has access to
   * @returns {Promise<Object>} Workspaces array
   */
  async getWorkspaces() {
    return await API.client.execute(GET, '/v1/workspace');
  }

  /**
   * Get workspace by ID
   * @param {string} workspaceId - Workspace ID
   * @returns {Promise<Object>} Workspace details
   */
  async getWorkspaceById(workspaceId) {
    return await API.client.execute(GET, `/v1/workspace/${workspaceId}`);
  }
}

export default new WorkspacesAPI();
